import { combineReducers } from '@reduxjs/toolkit';

import { bodyType } from './bodyType';
import { characteristic } from './characteristic';
import { mark } from './mark';
import { model } from './model';
import { modification } from './modification';
import { techData } from './techData';
import { type } from './type';

export default combineReducers({
    type,
    mark,
    modification,
    model,
    bodyType,
    techData,
    characteristic,
});
